module.exports = __webpack_public_path__ + "static/img/zhong20.cbd665e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong20.png
// module id = F2Sa
// module chunks = 16